import React from 'react';

interface SessionExpiredModalProps {
  onSignIn: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ onSignIn }) => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-anchor-navy border border-white/10 rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 text-center">
        <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-anchor-blue/10 border border-anchor-blue/20 flex items-center justify-center">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-anchor-blue">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h2 className="text-lg font-medium text-white mb-2">Session Expired</h2>
        <p className="text-sm text-white/50 mb-6 leading-relaxed">
          Your session has timed out due to inactivity. Please sign in again to continue.
        </p>

        <button
          onClick={onSignIn}
          className="w-full py-3 px-5 bg-anchor-blue border-none rounded-lg text-white text-sm cursor-pointer flex items-center justify-center gap-2.5 transition-all duration-300 hover:bg-[#3636DD] hover:-translate-y-px hover:shadow-[0_8px_28px_rgba(69,69,255,0.35)]"
        >
          <svg width="18" height="18" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
